import { Box, Tab, Tabs } from "@mui/material";
import { Link as RouterLink, useLocation } from "react-router-dom";
import {
  SUPERVISOR_WORKSPACE_NAV_ITEMS,
  isSupervisorWorkspaceNavSelected,
} from "./supervisorWorkspaceNav";

const PRIMARY = "#005B8F";

/**
 * Shared chrome for supervisor داشبورد / پروژه‌های جاری / پروژه‌های قبلی.
 * Scrollable tabs work on mobile; uses main SLN app shell (no nested sidebar).
 */
const SupervisorWorkspaceShell = ({ children, title, actions }) => {
  const location = useLocation();

  const activeId =
    SUPERVISOR_WORKSPACE_NAV_ITEMS.find((item) =>
      isSupervisorWorkspaceNavSelected(item, location.pathname)
    )?.id || false;

  return (
    <Box
      dir="rtl"
      data-testid="supervisor-workspace-shell"
      sx={{
        width: "100%",
        px: { xs: 1, sm: 1.5, md: 2 },
        py: { xs: 1, md: 1.5 },
        background: "#F6F8FB",
        minHeight: "100%",
        boxSizing: "border-box",
      }}
    >
      <Box
        component="nav"
        data-testid="supervisor-workspace-nav"
        sx={{
          mb: { xs: 1.5, md: 2 },
          borderBottom: 1,
          borderColor: "divider",
          bgcolor: "background.paper",
          borderRadius: 1,
          px: 0.5,
          position: "sticky",
          top: 0,
          zIndex: 2,
        }}
      >
        <Tabs
          value={activeId}
          variant="scrollable"
          scrollButtons="auto"
          allowScrollButtonsMobile
          textColor="primary"
          indicatorColor="primary"
          sx={{
            minHeight: 44,
            "& .MuiTabs-indicator": { bgcolor: PRIMARY, height: 3 },
            "& .MuiTab-root": {
              minHeight: 44,
              textTransform: "none",
              fontWeight: 700,
              color: "text.secondary",
              px: { xs: 1.25, md: 2 },
              fontSize: { xs: 13, md: 14 },
            },
            "& .Mui-selected": { color: `${PRIMARY} !important` },
          }}
        >
          {SUPERVISOR_WORKSPACE_NAV_ITEMS.map((item) => (
            <Tab
              key={item.id}
              value={item.id}
              label={item.labelFa}
              component={RouterLink}
              to={item.path}
              data-testid={`supervisor-workspace-nav-${item.id}`}
            />
          ))}
        </Tabs>
      </Box>

      {(title || actions) && (
        <Box
          sx={{
            display: "flex",
            flexDirection: { xs: "column", sm: "row" },
            alignItems: { xs: "stretch", sm: "center" },
            justifyContent: "space-between",
            gap: 1,
            mb: 1.5,
          }}
        >
          {title ? (
            <Box component="h1" sx={{ m: 0, fontSize: { xs: 18, md: 22 }, fontWeight: 800 }}>
              {title}
            </Box>
          ) : null}
          {actions ? (
            <Box
              sx={{
                display: "flex",
                flexWrap: "wrap",
                gap: 1,
                justifyContent: { xs: "stretch", sm: "flex-end" },
                "& > *": { flex: { xs: "1 1 auto", sm: "0 0 auto" } },
              }}
            >
              {actions}
            </Box>
          ) : null}
        </Box>
      )}

      <Box component="main" data-testid="supervisor-workspace-content">
        {children}
      </Box>
    </Box>
  );
};

export default SupervisorWorkspaceShell;
